import { FileEntity, FileTypeName, LegalClientEntity } from 'api/types/entity';
import { parseListDocumentsFiles } from 'modules/client/common/helpers';

export const parseLegalClientDocumentsFiles = (
  client: LegalClientEntity
): FileEntity[] =>
  parseListDocumentsFiles([
    {
      files: client.additionalDocumentFiles,
      type: FileTypeName.AdditionalDocument,
      uploadedByAdmin: true,
    },
    {
      files: client.signaturesCardFiles,
      type: FileTypeName.SignaturesCard,
    },
    {
      files: [client.invoice?.file],
      type: FileTypeName.Invoice,
    },
    {
      files: client.invoice?.paymentConfirmationFiles,
      type: FileTypeName.InvoicePaymentConfirmation,
    },
    {
      files: [client.questionnaireFile],
      type: FileTypeName.Questionnaire,
    },
    {
      files: client.signedQuestionnaireFiles,
      type: FileTypeName.SignedQuestionnaire,
    },
    {
      files: [client.clientServiceAgreementFiles_Global?.blank],
      type: FileTypeName.ClientServiceAgreement,
    },
    {
      files: [client.clientServiceAgreementFiles_Global?.companySigned],
      type: FileTypeName.CompanySignedClientServiceAgreement_Global,
    },
    {
      files: [client.clientServiceAgreementFiles_Global?.fullySigned],
      type: FileTypeName.FullySignedClientServiceAgreement,
    },
    {
      files: [client.companySignedNoticeOfInvestmentAccountOpeningFile],
      type: FileTypeName.CompanySignedNoticeOfInvestmentAccountOpening,
    },
  ]);
